import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getDisbursementApproverApprovedLoans = async ({
  startDate,
  endDate,
  email,
}) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.GET_APPROVED_LOANS}?workflowCode=adv_wk_test&email=${email}&startDate=${startDate}&endDate=${endDate}`
  );
  return data;
};

export default function useDisbursementApproverApprovedLoans({
  startDate,
  endDate,
  email,
}) {
  return useQuery(
    [{ startDate, endDate, email }, "getDisbursementApproverApprovedLoans"],
    getDisbursementApproverApprovedLoans,
    {
      refetchOnWindowFocus: false,
    }
  );
}
